import { forwardRef, type ReactNode } from 'react';

import { DataTestId } from '../../core/types/data-props.js';
import { StylingProps } from '../../core/types/styling-props.js';

//#region Typings
/**
 * Accepted properties for the TitleBar Action
 * @public
 */
export interface TitleBarActionProps extends StylingProps, DataTestId {
  /** Elements to be displayed in the TitleBar Action slot. */
  children: ReactNode;
}
//#endregion

/**
 * TitleBar Action component
 * @public
 */
export const Action = /* @__PURE__ */ forwardRef<
  HTMLDivElement,
  TitleBarActionProps
>((props, forwardedRef) => {
  const {
    children,
    className: consumerClassName,
    style: consumerStyle,
    'data-testid': dataTestId,
  }: TitleBarActionProps = props;

  return (
    <div
      ref={forwardedRef}
      className={consumerClassName}
      style={consumerStyle}
      data-testid={dataTestId}
    >
      {children}
    </div>
  );
});
